import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { contactConfig } from "../../config/contact";
import { useLocalizedLink } from "../../hooks/useLocalizedLink";

function FooterOne() {
  const { t } = useTranslation();
  const getLocalizedPath = useLocalizedLink();

  return (
    <footer className="footer-wrapper footer-layout1">
      <div className="widget-area">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-md-6 col-xl-3">
              <div className="widget footer-widget">
                <div className="th-widget-about">
                  <div className="about-logo">
                    <Link to={getLocalizedPath("/")}>
                      <img
                        src="/assets/img/logo-haseki.png"
                        alt="Haseki Sultan Kız Yurdu"
                        className="img-fluid"
                        style={{ maxWidth: "180px", height: "auto" }}
                      />
                    </Link>
                  </div>
                  <p
                    className="about-text"
                    dangerouslySetInnerHTML={{ __html: t("footer.aboutText") }}
                  />
                  <p
                    className="about-text"
                    style={{ marginTop: "10px", fontSize: "14px" }}
                  >
                    <strong
                      dangerouslySetInnerHTML={{
                        __html: t("footer.commercialNotice"),
                      }}
                    />
                  </p>
                  <div className="th-social">
                    <Link
                      to={contactConfig.social.instagram}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-auto">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title">{t("common.quickLinks")}</h3>
                <div className="menu-all-pages-container">
                  <ul className="menu">
                    <li>
                      <Link to={getLocalizedPath("/")}>{t("nav.home")}</Link>
                    </li>
                    <li>
                      <Link to={getLocalizedPath("/service")}>
                        {t("nav.services")}
                      </Link>
                    </li>
                    <li>
                      <Link to={getLocalizedPath("/contact")}>
                        {t("nav.onlineRegistration")}
                      </Link>
                    </li>
                    <li>
                      <Link to={getLocalizedPath("/about")}>
                        {t("nav.about")}
                      </Link>
                    </li>
                    <li>
                      <Link to={getLocalizedPath("/contact")}>
                        {t("nav.contact")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-auto">
              <div className="widget footer-widget">
                <h3 className="widget_title">{t("footer.address")}</h3>
                <div className="th-widget-contact">
                  <div className="info-box_text">
                    <div className="icon">
                      <img src="/assets/img/icon/phone.svg" alt="img" />
                    </div>
                    <div className="details">
                      <p>
                        <Link
                          to={`tel:${contactConfig.phone.primary.replace(
                            /\s/g,
                            ""
                          )}`}
                          className="info-box_link"
                        >
                          {contactConfig.phone.primary}
                        </Link>
                      </p>
                      <p>
                        <Link
                          to={`tel:${contactConfig.phone.secondary.replace(
                            /\s/g,
                            ""
                          )}`}
                          className="info-box_link"
                        >
                          {contactConfig.phone.secondary}
                        </Link>
                      </p>
                    </div>
                  </div>
                  <div className="info-box_text">
                    <div className="icon">
                      <img src="/assets/img/icon/envelope.svg" alt="img" />
                    </div>
                    <div className="details">
                      <p>
                        <Link
                          to={`mailto:${contactConfig.email.primary}`}
                          className="info-box_link"
                        >
                          {contactConfig.email.primary}
                        </Link>
                      </p>
                      <p>
                        <Link
                          to={`mailto:${contactConfig.email.support}`}
                          className="info-box_link"
                        >
                          {contactConfig.email.support}
                        </Link>
                      </p>
                    </div>
                  </div>
                  <div className="info-box_text">
                    <div className="icon">
                      <img src="/assets/img/icon/location-dot.svg" alt="img" />
                    </div>
                    <div className="details">
                      <p>{contactConfig.address.full}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-auto">
              <div className="widget footer-widget">
                <h3 className="widget_title">{t("footer.instagramPost")}</h3>
                <div className="sidebar-gallery">
                  <div className="gallery-thumb">
                    <img
                      src="/assets/img/yurt-fotograf/yemekhane/5.jpg"
                      alt="Haseki Sultan Kız Yurdu - Yemekhane"
                      title="Haseki Sultan Kız Yurdu - Yemekhane"
                    />
                    <Link
                      target="_blank"
                      to={contactConfig.social.instagram}
                      className="gallery-btn"
                    >
                      <i className="fab fa-instagram" />
                    </Link>
                  </div>
                  <div className="gallery-thumb">
                    <img
                      src="/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/4.jpg"
                      alt="Haseki Sultan Kız Yurdu - 3 Kişilik Oda"
                      title="Haseki Sultan Kız Yurdu - 3 Kişilik Oda"
                    />
                    <Link
                      target="_blank"
                      to={contactConfig.social.instagram}
                      className="gallery-btn"
                    >
                      <i className="fab fa-instagram" />
                    </Link>
                  </div>
                  <div className="gallery-thumb">
                    <img
                      src="/assets/img/yurt-fotograf/teras/7.jpg"
                      alt="Haseki Sultan Kız Yurdu - Teras"
                      title="Haseki Sultan Kız Yurdu - Teras"
                    />
                    <Link
                      target="_blank"
                      to={contactConfig.social.instagram}
                      className="gallery-btn"
                    >
                      <i className="fab fa-instagram" />
                    </Link>
                  </div>
                  <div className="gallery-thumb">
                    <img
                      src="/assets/img/yurt-fotograf/yemekhane/42.jpg"
                      alt="Haseki Sultan Kız Yurdu - Yemekhane"
                      title="Haseki Sultan Kız Yurdu - Yemekhane"
                    />
                    <Link
                      target="_blank"
                      to={contactConfig.social.instagram}
                      className="gallery-btn"
                    >
                      <i className="fab fa-instagram" />
                    </Link>
                  </div>
                  <div className="gallery-thumb">
                    <img
                      src="/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/10.jpg"
                      alt="Haseki Sultan Kız Yurdu - 3 Kişilik Oda"
                      title="Haseki Sultan Kız Yurdu - 3 Kişilik Oda"
                    />
                    <Link
                      target="_blank"
                      to={contactConfig.social.instagram}
                      className="gallery-btn"
                    >
                      <i className="fab fa-instagram" />
                    </Link>
                  </div>
                  <div className="gallery-thumb">
                    <img
                      src="/assets/img/yurt-fotograf/etut/1.jpg"
                      alt="Haseki Sultan Kız Yurdu - Etüt Odası"
                      title="Haseki Sultan Kız Yurdu - Etüt Odası"
                    />
                    <Link
                      target="_blank"
                      to={contactConfig.social.instagram}
                      className="gallery-btn"
                    >
                      <i className="fab fa-instagram" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="copyright-wrap background-image"
        style={{
          backgroundImage:
            "url('/assets/img/yurt-fotograf/breadcrumb-banner.png')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
        role="img"
        aria-label="Haseki Sultan Kız Öğrenci Yurdu - Copyright Arka Plan"
        title="Haseki Sultan Kız Öğrenci Yurdu - Copyright"
      >
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-md-6">
              <p className="copyright-text">
                {t("footer.copyright")}{" "}
                <Link to={getLocalizedPath("/")}>Haseki Sultan Kız Yurdu</Link>.{" "}
                {t("footer.allRightsReserved")}
              </p>
            </div>
            <div className="col-md-6 text-end d-none d-md-block">
              <div className="footer-card">
                <img src="/assets/img/shape/cards.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterOne;
